import React from "react";
import { useAuthContext } from "../../context/AuthContext";
import { ROLES } from "../../constants";
import AdminDashboard from "./AdminDashboard";
import GVCNDashboard from "./GVCNDashboard";
import TruongNganhDashboard from "./TruongNganhDashboard";
import GVPhuDashboard from "./GVPhuDashboard";

const Dashboard = () => {
  const { hasRole } = useAuthContext();

  if (hasRole(ROLES.ADMIN)) return <AdminDashboard />;
  if (hasRole(ROLES.TRUONG_NGANH)) return <TruongNganhDashboard />;
  if (hasRole(ROLES.GVCN)) return <GVCNDashboard />;
  if (hasRole(ROLES.GV_PHU)) return <GVPhuDashboard />;

  return <GVCNDashboard />;
};

export default Dashboard;